import ServiceBus from "servicestack/service-bus";
import basicController from "servicestack/basic.controller.properties";
import cartConfig from "emun.cart/cart.config";
// import moment from "moment";
import AutoQuery from "servicestack/auto-query/auto-query";

export default class RetrieveTokenInfoController {
	constructor(options) {
		const $ctrl = this;
		basicController($ctrl);
		$ctrl.bus = new ServiceBus();
		$ctrl.config = cartConfig;
    $ctrl.token = options.token;
    $ctrl.cvv = options.cvv;
		$ctrl.title = options.title || "Token Information";
	}
	$onInit() {
		const $ctrl = this;
        $ctrl.bus.read('RetrieveTokenInfo.json?Token=' + $ctrl.token).then(res=> {
            $ctrl.tokenInfo = res.data;
        });
	}
}
